export const REFERRAL_SOURCE_FETCH_ONE_REQUEST =
  'REFERRAL_SOURCE_FETCH_ONE_REQUEST';
export const REFERRAL_SOURCE_FETCH_ONE = 'REFERRAL_SOURCE_FETCH_ONE';
export const REFERRAL_SOURCE_FETCH_MANY_REQUEST =
  'REFERRAL_SOURCE_FETCH_MANY_REQUEST';
export const REFERRAL_SOURCE_FETCH_MANY = 'REFERRAL_SOURCE_FETCH_MANY';
export const REFERRAL_SOURCE_CREATE_REQUEST = 'REFERRAL_SOURCE_CREATE_REQUEST';
export const REFERRAL_SOURCE_CREATE = 'REFERRAL_SOURCE_CREATE';
